export enum PaymentStatus {
  ALL = 'all',
  PAID = 'paid',
  PARTIALLY_PAID = 'partially paid',
  UPCOMING = 'upcoming',
  PENDING = 'pending',
  FULL_REFUND = 'full refund',
  PARTIAL_REFUND = 'partial refund',
  PENDING_REFUND = 'refund processing',
  REFUND_FAILED = 'refund failed',
  VOID = 'void',
  FAILED = 'failed',
  SCHEDULED = 'scheduled',
  INVOICE_SCHEDULED = 'invoice scheduled',
  PAUSED = 'paused',
  PROCESSING = 'processing',
  CANCELLED = 'cancelled',
  FREE = 'free',
}
